/**
 *  Intercepts all calls to the backend and adds the auth token to the request header
 */

import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {AuthenticationService} from '@authentication/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // AuthenticationService will be lazy-loaded to break the cycle
  private authenticationService: AuthenticationService | null = null;
  skipURL = /^https?:\/\/s3\.amazonaws\.com.*|^https?:\/\/www\.google-analytics\.com.*/;

  constructor(private readonly injector: Injector) {}

  intercept(req: HttpRequest<never>, next: HttpHandler) {
    // Lazily load AuthenticationService
    if (!this.authenticationService) {
      this.authenticationService = this.injector.get(AuthenticationService);
    }
    const token = this.authenticationService.token();

    // Remove authorization headers when the EPPN is missing.
    if (req.headers.has('eppn') && req.headers.get('eppn') == 'no_eppn') {
      req = req.clone({
        setHeaders: {},
      });
      return next.handle(req);
    }

    // Don't add authorization headers when making AWS S3 or Google Analytics requests.
    if (!this.skipURL.test(req.url) && token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // send cloned request with header to the next handler.
    return next.handle(req);
  }
}
